// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Caml_option = require("rescript/lib/js/caml_option.js");
var PageUITitle = require("../../components/PageTitle/PageUITitle.bs.js");
var TMPUIKIT____Page = require("../../temporaryUIKit/TMPUIKIT____Page/TMPUIKIT____Page.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var RescriptRelay_Query = require("rescript-relay/src/RescriptRelay_Query.bs.js");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var MarkupHelpers = require("components/MarkupHelpers");
var BillingSettingsPagePaymentCard = require("./BillingSettingsPagePaymentCard.bs.js");
var BillingSettingsPageSubscription = require("./BillingSettingsPageSubscription.bs.js");
var BillingSettingsPageRelayQuery_graphql = require("../../__generated__/BillingSettingsPageRelayQuery_graphql.bs.js");
var BillingSettingsPageRelay_accountV5_graphql = require("../../__generated__/BillingSettingsPageRelay_accountV5_graphql.bs.js");

var convertFragment = BillingSettingsPageRelay_accountV5_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, BillingSettingsPageRelay_accountV5_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(BillingSettingsPageRelay_accountV5_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, BillingSettingsPageRelay_accountV5_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(BillingSettingsPageRelay_accountV5_graphql.node, convertFragment, fRef);
}

var AccountFragment_planType_decode = BillingSettingsPageRelay_accountV5_graphql.Utils.planType_decode;

var AccountFragment_planType_fromString = BillingSettingsPageRelay_accountV5_graphql.Utils.planType_fromString;

var AccountFragment = {
  planType_decode: AccountFragment_planType_decode,
  planType_fromString: AccountFragment_planType_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

var convertVariables = BillingSettingsPageRelayQuery_graphql.Internal.convertVariables;

var convertResponse = BillingSettingsPageRelayQuery_graphql.Internal.convertResponse;

var convertWrapRawResponse = BillingSettingsPageRelayQuery_graphql.Internal.convertWrapRawResponse;

var use$1 = RescriptRelay_Query.useQuery(convertVariables, BillingSettingsPageRelayQuery_graphql.node, convertResponse);

var useLoader = RescriptRelay_Query.useLoader(convertVariables, BillingSettingsPageRelayQuery_graphql.node, (function (prim) {
        return prim;
      }));

var usePreloaded = RescriptRelay_Query.usePreloaded(BillingSettingsPageRelayQuery_graphql.node, convertResponse, (function (prim) {
        return prim;
      }));

var $$fetch = RescriptRelay_Query.$$fetch(BillingSettingsPageRelayQuery_graphql.node, convertResponse, convertVariables);

var fetchPromised = RescriptRelay_Query.fetchPromised(BillingSettingsPageRelayQuery_graphql.node, convertResponse, convertVariables);

var retain = RescriptRelay_Query.retain(BillingSettingsPageRelayQuery_graphql.node, convertVariables);

var Query = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  use: use$1,
  useLoader: useLoader,
  usePreloaded: usePreloaded,
  $$fetch: $$fetch,
  fetchPromised: fetchPromised,
  retain: retain
};

function BillingSettingsPageRelay(props) {
  var data = use$1(undefined, undefined, undefined, undefined);
  var account = use(data.currentAccountV5.fragmentRefs);
  var match = account.sub.plan.planType;
  var tmp;
  var exit = 0;
  if ((match === "PRO" || match === "FREE" || match === "COMPLIMENTARY" || match === "PRO_ONLY") && match === "FREE") {
    tmp = null;
  } else {
    exit = 1;
  }
  if (exit === 1) {
    tmp = JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx(TMPUIKIT____Page.Subtitle.make, {
                  children: "Payment Method"
                }),
            JsxRuntime.jsx(BillingSettingsPagePaymentCard.make, {
                  account: account.fragmentRefs
                })
          ]
        });
  }
  return JsxRuntime.jsxs(MarkupHelpers.ContentBox, {
              paddingFull: true,
              hasShadow: true,
              children: [
                JsxRuntime.jsx(PageUITitle.make, {
                      title: "Billing"
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        tmp,
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx(TMPUIKIT____Page.Subtitle.make, {
                                      children: "Current Subscription"
                                    }),
                                JsxRuntime.jsx(BillingSettingsPageSubscription.make, {
                                      account: account.fragmentRefs
                                    })
                              ]
                            })
                      ],
                      className: "flex flex-col gap-8"
                    })
              ]
            });
}

var SubTitle;

var make = BillingSettingsPageRelay;

exports.AccountFragment = AccountFragment;
exports.Query = Query;
exports.SubTitle = SubTitle;
exports.make = make;
/* use Not a pure module */
